// Thin wrapper around Google Analytics gtag for custom events.
// Safely no-ops if gtag is not loaded (local dev, adblock, etc).

const GA_ID = 'G-C2X5GXCJ88';
const DISABLE_KEY = `ga-disable-${GA_ID}`;

// Routes where GA should NEVER fire (super admin = private ops, should not pollute analytics).
const isBlockedPath = (path) => (path || '').startsWith('/admin');

const isReady = () =>
  typeof window !== 'undefined' &&
  typeof window.gtag === 'function' &&
  !window[DISABLE_KEY];

export const trackEvent = (eventName, params = {}) => {
  try {
    if (!isReady()) return;
    if (typeof window !== 'undefined' && isBlockedPath(window.location?.pathname)) return;
    window.gtag('event', eventName, params);
  } catch (_) { /* swallow */ }
};

// Specific helpers
export const trackDemoRequest = ({ source, property_type, mobile, city, beds, name }) => {
  trackEvent('demo_request_submit', {
    source: source || 'homepage-hero',
    property_type: property_type || 'unknown',
    has_name: Boolean(name),
    has_city: Boolean(city),
    has_beds: Boolean(beds),
    mobile_len: mobile ? String(mobile).length : 0
  });
  // also mirror a generate_lead event (GA4 recommended event)
  trackEvent('generate_lead', {
    currency: 'INR',
    value: 0,
    source: source || 'homepage-hero'
  });
};

export const trackSignupRequest = (payload = {}) => {
  trackEvent('signup_request_submit', {
    has_name: Boolean(payload.name),
    has_city: Boolean(payload.city)
  });
};
